const highMediumLow = [
    { key: "HIGH", value: "HIGH" },
    { key: "MEDIUM", value: "MEDIUM" },
    { key: "LOW", value: "LOW" },
];

export { highMediumLow };